export default __webpack_public_path__ + "static/media/Icon-Revocation.da8f01fc.svg";